import AppointmentInfoContainer from './AppointmentInfoContainer';

export default AppointmentInfoContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/AppointmentInfo/index.js